package org.example.project.service

import kotlinx.browser.window
import kotlinx.browser.document
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.await
import kotlinx.coroutines.launch

/** The worker associated with the document at startup, before login changes cookies. */
private var loadedLoginBuild = ""
private var buildReloadStarted = false
private var resumeCheckInstalled = false

fun installLoginBuildResumeCheck() {
    if (resumeCheckInstalled) return
    resumeCheckInstalled = true
    val scope = MainScope()
    fun checkLoginBuild() {
        if (!LoginService.isLoggedIn()) scope.launch { reloadForLatestLoginBuild() }
    }
    window.addEventListener("pageshow", { checkLoginBuild() })
    document.addEventListener("visibilitychange", {
        if (document.asDynamic().visibilityState == "visible") checkLoginBuild()
    })
}

private fun cleanLoginBuild(value: String): String =
    value.trim().removePrefix("V ").removePrefix("build_").trim()

/** Returns true when navigation has started; callers must stop their login request. */
suspend fun reloadForLatestLoginBuild(): Boolean {
    if (buildReloadStarted) return true
    return runCatching {
        if (loadedLoginBuild.isBlank()) {
            val current = window.fetch("/__version", js("({ cache: 'no-store' })")).await()
            if (!current.ok) return@runCatching false
            loadedLoginBuild = cleanLoginBuild(current.text().await())
        }
        if (!Regex("\\d+\\.\\d+\\.\\d+").matches(loadedLoginBuild)) return@runCatching false
        val response = window.fetch("/node/status", js("({ cache: 'no-store' })")).await()
        if (!response.ok) return@runCatching false
        val status = JSON.parse<dynamic>(response.text().await())
        val preferred = cleanLoginBuild(status.preferredBuild?.toString().orEmpty())
        if (!Regex("\\d+\\.\\d+\\.\\d+").matches(preferred) || preferred == loadedLoginBuild) {
            return@runCatching false
        }
        buildReloadStarted = true
        window.location.reload()
        true
    }.getOrDefault(false)
}
